import React from 'react';
import { InputGroup, FormControl, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { AnyType } from '../interfaces';

// TODO: Make this reusable. - vic

interface UserSearchProps {
  onSearch?: (value: string | undefined) => void;
}

export const UserSearch = (props: UserSearchProps) => {
  const onSearch = (e: AnyType) => {
    e.preventDefault();
    const value = e.target.value;
    props.onSearch && props.onSearch(value);
  };

  return (
    <InputGroup>
      <InputGroup.Text className=' bg-transparent msg_search-icon'>
        <i className='fa-regular fa-magnifying-glass text-secondary'></i>
      </InputGroup.Text>
      <FormControl
        placeholder='Search Users'
        onChange={onSearch}
        aria-label='Patient'
        aria-describedby='basic-addon1'
        className='search_input'
      />
    </InputGroup>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export const ConnectedUserSearch = connect(mapStateToProps, mapDispatchToProps)(UserSearch);
